import { fromJS, Set as ISet } from 'immutable';

export const UPDATE_FLOW_STATE = '@@storefront/UPDATE_FLOW_STATE';
export const RESET_FLOW_STATE = '@@storefront/RESET_FLOW_STATE';

export const initialFlowProgressState = fromJS({
    progress: ISet()
});






export const flowProgressReducer = function flowProgressReducer(state = initialFlowProgressState, action) {
    switch (action.type) {
        case UPDATE_FLOW_STATE:
            return state.mergeIn(['progress'], action.progress);
        case RESET_FLOW_STATE:
            return state.set('progress', ISet());
        default:
            return state;
    }
};


export function updateFlowProgress(progress) {
    return {
        type: UPDATE_FLOW_STATE,
        progress
    };
}


export function resetFlowState() {
    return {
        type: RESET_FLOW_STATE
    };
}
